
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AppBar from '@/components/Menu/AppBar.vue'
import MenuDrawer from '@/components/Menu/MenuDrawer.vue'
import EventDrawer from '@/components/Menu/EventsDrawer.vue'
import UserModule from '@/store/modules/UserModule'
import CacheStore from './store/cache-store'

@Component({
  components: {
    AppBar,
    MenuDrawer,
    EventDrawer
  }
})
export default class AppComponent extends Vue {
  public eventDrawer: boolean = false
  public msg = '' as string

  public mounted () {
    this.connectUser()
  }

  public get URLLOGIN () {
    return `${process.env.VUE_APP_BASE_API_URL}/api/Saml/InitiateSingleSignOn?returnurl=${process.env.VUE_APP_BASE_CLIENT_URL}`
  }

  public get isAuthenticated () {
    return UserModule.isConnected
  }

  private connectUser () {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const query = Object.fromEntries(urlSearchParams.entries())
    let token : string | null = null

    if (query.jwt && query.jwt !== null) {
      token = query.jwt
      delete query.jwt
      this.$router.replace({ query })
    } else {
      token = CacheStore.getFromSession(CacheStore.TOKEN)
    }

    if (token !== null && token !== '') {
      UserModule.updateToken(token)
      UserModule.loadUserInformation().catch(() => {
        this.redirectUserToAuth()
      })
    } else {
      this.redirectUserToAuth()
    }
  }

  private redirectUserToAuth (): Promise<any> {
    CacheStore.removeFromSession(CacheStore.TOKEN)
    const baliseA = document.getElementById('urlAuth')
    if (baliseA) {
      baliseA.click()
      return Promise.resolve()
    } else {
      return Promise.reject(new Error('No balise <a> found'))
    }
  }
}

